import styled, { css } from 'styled-components';
import { Typography } from '../Typography';
import { Placement } from './constants/placement';
type TooltipTextProps = {
  placement?: 'left' | 'right' | 'top' | 'bottom';
  tooltipColor?: string;
};

// TODO - Create robust styling mechanism
export const TooltipText = styled(Typography)<TooltipTextProps>`
  ${({
  tooltipColor = '#FF5867',
  placement,
  // Dynamic value for margin left and border width allows
  // easy adjustment of arrow location and width
  marginLeft = '-5px',
  borderWidth = '5px'
}) => css`
    &:after {
      content: ' ';
      position: absolute;
      margin-left: ${marginLeft.toString()};
      border-width: ${borderWidth.toString()};
      border-style: solid;
      ${placement === Placement.Top && `
        top: 100%;
        left: 50%;
        border-color: ${tooltipColor} transparent transparent transparent;
      `}
      ${placement === Placement.Bottom && `
        bottom: 100%;
        left: 50%;
        border-color: transparent transparent ${tooltipColor} transparent;
      `}
      ${placement === Placement.Left && `
        top: 35%;
        left: 50%;
        border-color: transparent transparent transparent ${tooltipColor};
      `}
      ${placement === Placement.Right && `
        top: 40%;
        right: 100%;
        border-color: transparent ${tooltipColor} transparent transparent;
      `}
    }
  `}
`;